(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-image"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-scraplife-image-scroll-zoom]';
    const sections = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 767px)');
    let frame = 0;
    let previousTime = 0;

    // Change these values to adjust the maximum zoom: 0.08 means 8%.
    const desktopZoom = 0.08;
    const mobileZoom = 0.06;

    function schedule() {
      if (frame || !sections.size) return;
      previousTime = 0;
      frame = window.requestAnimationFrame(update);
    }

    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(schedule)
      : null;

    function unmount(root) {
      const entry = sections.get(root);
      if (!entry) return;
      if (resizeObserver) resizeObserver.unobserve(root);
      entry.image.removeAttribute('data-scraplife-scroll-zoom-image');
      entry.image.style.removeProperty('--scraplife-scroll-scale');
      entry.image.style.willChange = entry.originalWillChange;
      sections.delete(root);

      if (!sections.size && frame) {
        window.cancelAnimationFrame(frame);
        frame = 0;
      }
    }

    function update(time) {
      frame = 0;
      const elapsed = previousTime ? Math.min(time - previousTime, 64) : 16;
      const smoothing = 1 - Math.exp(-elapsed / 100);
      previousTime = time;
      const viewportHeight = window.innerHeight;
      const zoom = mobile.matches ? mobileZoom : desktopZoom;
      let keepAnimating = false;
      const updates = [];

      // Read positions before applying image styles. Scaling never changes layout.
      sections.forEach((entry, root) => {
        if (!root.isConnected) {
          unmount(root);
          return;
        }

        const bounds = root.getBoundingClientRect();
        const visible = bounds.bottom > 0 && bounds.top < viewportHeight;
        const progress = Math.max(0, Math.min(1, -bounds.top / Math.max(bounds.height, 1)));
        const target = reducedMotion.matches ? 1 : 1 + progress * zoom;

        if (entry.scale === null || !visible || reducedMotion.matches) {
          entry.scale = target;
        } else {
          entry.scale += (target - entry.scale) * smoothing;
          if (Math.abs(target - entry.scale) > 0.0001) {
            keepAnimating = true;
          } else {
            entry.scale = target;
          }
        }

        updates.push({ entry, visible });
      });

      updates.forEach(({ entry, visible }) => {
        entry.image.style.setProperty('--scraplife-scroll-scale', entry.scale.toFixed(4));
        entry.image.style.willChange = visible && !reducedMotion.matches
          ? 'scale'
          : entry.originalWillChange;
      });

      if (keepAnimating && sections.size) {
        frame = window.requestAnimationFrame(update);
      }
    }

    function mount(root) {
      if (sections.has(root)) return;
      const container = root.querySelector('.section-image__container');
      if (!container) return;
      const image = container.querySelector('img.section-image__image, .section-image__image img')
        || container.querySelector('img');
      if (!image) return;

      image.setAttribute('data-scraplife-scroll-zoom-image', '');
      sections.set(root, { image, scale: null, originalWillChange: image.style.willChange });
      if (resizeObserver) resizeObserver.observe(root);
      schedule();
    }

    function mountWithin(parent) {
      if (parent.matches && parent.matches(selector)) mount(parent);
      parent.querySelectorAll(selector).forEach(mount);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    reducedMotion.addEventListener('change', schedule);
    mobile.addEventListener('change', schedule);

    // Shopify re-renders sections without a full page refresh in its theme editor.
    document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      sections.forEach((entry, root) => {
        if (event.target === root || event.target.contains(root)) unmount(root);
      });
    });
    document.addEventListener('shopify:section:reorder', schedule);
    document.addEventListener('load', (event) => {
      if (event.target instanceof HTMLImageElement) schedule();
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountWithin(document), { once: true });
    } else {
      mountWithin(document);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
